module.exports = __webpack_public_path__ + "img/sketch-green-end.a86145ad.png";